const transportTypeDatabase = 'Database Tipe Kendaraan'
const searchText = 'Cari Tipe Kendaraan'
const searchVehicleNo = 'Cari No. Kendaraan'
const photo = 'Foto'
const createTransportType = 'Buat Tipe Kendaraan'
const editTransportType = 'Ubah Tipe Kendaraan'
const name = 'Nama tipe Kendaraan'
const vehicleType = 'Tipe Kendaraan'
const vehicleNo = 'No. Kendaraan'
const dimension = 'Dimensi'
const length = 'Panjang'
const width = 'Lebar'
const height = 'Tinggi'
const volume = 'Volume'
const weight = 'Bobot'
const max = 'Maksimum'
const maxWeight = weight + ' ' + max
const image = 'Gambar'
const inner = '(inner)'
const centimeter = 'cm'
const cubicMeter = 'm³'
const tonne = 'ton'

export default {
  transportTypeDatabase,
  searchText,
  photo,
  createTransportType,
  editTransportType,
  name,
  dimension,
  length,
  width,
  height,
  volume,
  weight,
  maxWeight,
  image,
  inner,
  centimeter,
  cubicMeter,
  tonne,
  vehicleType,
  vehicleNo,
  searchVehicleNo,
}
